import { render, staticRenderFns } from "./ReorderCertifications.vue?vue&type=template&id=46fde606&scoped=true"
import script from "./ReorderCertifications.vue?vue&type=script&lang=js"
export * from "./ReorderCertifications.vue?vue&type=script&lang=js"
import style0 from "./ReorderCertifications.vue?vue&type=style&index=0&id=46fde606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fde606",
  null
  
)

/* custom blocks */
import block0 from "./ReorderCertifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports